export default "__VITE_ASSET__BWby4wJr__"